/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { BootstrapDialog, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  MenuItem
} from '@mui/material';

import Iconify from '../../../../@core/theme/Iconify';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import configAxios from '../../../../services/configAxios';

const addEditLeadsCatalog = (props) => {
  const [infosItem, setInfosItem] = useState({});

  useEffect(() => {
    setInfosItem(props.infosItemEdit ? props.infosItemEdit : {});
  }, [props.infosItemEdit]);

  const isEdit = Boolean(
    infosItem.id_acquisition ||
      infosItem.id_loss ||
      infosItem.id_status_lead ||
      infosItem.id_tag ||
      infosItem.id_action
  );

  function HandleInputChange(event) {
    setInfosItem({ ...infosItem, [event.target.name]: event.target.value });
  }

  function HandleSubmit(event) {
    event.preventDefault();

    let router = '';
    if (props.type === 'acquisition') {
      router = infosItem.id_acquisition ? '/leads/updateAcquisition' : '/leads/addAcquisition';
    } else if (props.type === 'loss') {
      router = infosItem.id_loss ? '/leads/updateLoss' : '/leads/addLoss';
    } else if (props.type === 'status') {
      router = infosItem.id_status_lead ? '/leads/updateStatusLead' : '/leads/addStatusLead';
    } else if (props.type === 'tag') {
      router = infosItem.id_tag ? '/leads/updateTag' : '/leads/addTag';
    } else if (props.type === 'action') {
      router = infosItem.id_action ? '/leads/updateAction' : '/leads/addAction';
    }

    let notification = isEdit
      ? 'Registro atualizado com sucesso!'
      : 'Registro adicionado com sucesso!';

    configAxios
      .post(router, infosItem)
      .then(() => {
        props.setOpenModal(false);
        props.functionGrid();
        setInfosItem({});
        NotificationManager.success(notification, 'Sucesso');
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  return (
    <>
      <div>
        <BootstrapDialog
          onClose={() => {
            props.setOpenModal(false);
            props.functionGrid();
          }}
          aria-labelledby="customized-dialog-title"
          fullWidth
          maxWidth={'sm'}
          open={props.openModal}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => {
              props.setOpenModal(false);
              props.functionGrid();
              setInfosItem({});
            }}>
            {isEdit ? 'Editar registro' : 'Novo registro'}
          </BootstrapDialogTitle>
          <form onSubmit={HandleSubmit}>
            <DialogContent dividers>
              <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
              <Grid container spacing={2} sx={{ mb: 1, mt: 1 }}>
                {props.type === 'acquisition' && (
                  <Grid item xs={12}>
                    <TextField
                      name="canal"
                      fullWidth
                      label="Canal"
                      variant="outlined"
                      size="small"
                      required
                      value={infosItem.canal || ''}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>
                )}
                {props.type === 'loss' && (
                  <Grid item xs={12}>
                    <TextField
                      name="motivo"
                      fullWidth
                      label="Motivo"
                      variant="outlined"
                      size="small"
                      required
                      value={infosItem.motivo || ''}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>
                )}
                {props.type === 'status' && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        name="status"
                        fullWidth
                        label="Status"
                        variant="outlined"
                        size="small"
                        required
                        value={infosItem.status || ''}
                        onChange={(event) => HandleInputChange(event)}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        name="ordem"
                        fullWidth
                        label="Ordem"
                        variant="outlined"
                        type="number"
                        size="small"
                        value={infosItem.ordem ?? ''}
                        onChange={(event) => HandleInputChange(event)}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        select
                        name="fundo"
                        fullWidth
                        label="Fundo"
                        variant="outlined"
                        size="small"
                        value={infosItem.fundo === 'S' ? 'S' : 'N'}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value="S">Sim</MenuItem>
                        <MenuItem value="N">Não</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        select
                        name="perdido"
                        fullWidth
                        label="Perdido"
                        variant="outlined"
                        size="small"
                        value={infosItem.perdido === 'S' ? 'S' : 'N'}
                        onChange={(event) => HandleInputChange(event)}>
                        <MenuItem value="S">Sim</MenuItem>
                        <MenuItem value="N">Não</MenuItem>
                      </TextField>
                    </Grid>
                  </>
                )}
                {props.type === 'tag' && (
                  <>
                    <Grid item xs={12} md={8}>
                      <TextField
                        name="tag"
                        fullWidth
                        label="Tag"
                        variant="outlined"
                        size="small"
                        required
                        value={infosItem.tag || ''}
                        onChange={(event) => HandleInputChange(event)}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        name="cor"
                        fullWidth
                        label="Cor"
                        variant="outlined"
                        type="color"
                        size="small"
                        value={infosItem.cor || '#0E4B4B'}
                        onChange={(event) => HandleInputChange(event)}
                      />
                    </Grid>
                  </>
                )}
                {props.type === 'action' && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        name="acao"
                        fullWidth
                        label="Ação"
                        variant="outlined"
                        size="small"
                        required
                        value={infosItem.acao || ''}
                        onChange={(event) => HandleInputChange(event)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        name="ordem"
                        fullWidth
                        label="Ordem"
                        variant="outlined"
                        type="number"
                        size="small"
                        value={infosItem.ordem ?? ''}
                        onChange={(event) => HandleInputChange(event)}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        name="sla"
                        fullWidth
                        label="SLA (dias)"
                        variant="outlined"
                        type="number"
                        size="small"
                        value={infosItem.sla ?? ''}
                        onChange={(event) => HandleInputChange(event)}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                color="success"
                variant="contained"
                type="submit"
                startIcon={<Iconify icon="eva:save-fill" />}>
                {isEdit ? 'Atualizar' : 'Salvar'}
              </Button>
              <Button
                onClick={() => {
                  props.setOpenModal(false);
                  props.functionGrid();
                  setInfosItem({});
                }}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Cancelar
              </Button>
            </DialogActions>
          </form>
        </BootstrapDialog>
      </div>
    </>
  );
};

addEditLeadsCatalog.propTypes = {
  openModal: PropTypes.bool,
  setOpenModal: PropTypes.func,
  type: PropTypes.string,
  infosItemEdit: PropTypes.object,
  functionGrid: PropTypes.func
};

export default addEditLeadsCatalog;
